import { render, staticRenderFns } from "./AccountContainer.vue?vue&type=template&id=2b565cfc"
import script from "./AccountContainer.vue?vue&type=script&lang=js"
export * from "./AccountContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports